import { FintechPapiEmployee, FintechPapiJob } from 'src/api/interfaces';

export interface ProfileInfo {
  jobTitle?: string;
  jobLevel?: string;
  city?: string;
  buildingCode?: string;
  badgeColor?: string;
}

/** Maps PAPI badge color names to hex values (matching baseball card conventions) */
export const BADGE_COLOR_MAP: Record<string, string> = {
  blue: '#0073bb',
  green: '#1d8102',
  yellow: '#f2a900',
  orange: '#f2a900',
  red: '#d13212'
};

/** Maps PAPI badge color names to box-shadow glow values */
export const BADGE_SHADOW_MAP: Record<string, string> = {
  blue: '0 0 10px 2px rgba(0, 115, 187, 0.70)',
  green: '0 0 10px 2px rgba(29, 129, 2, 0.70)',
  yellow: '0 0 10px 2px rgba(242, 169, 0, 0.70)',
  orange: '0 0 10px 2px rgba(242, 169, 0, 0.70)',
  red: '0 0 10px 2px rgba(209, 50, 18, 0.70)'
};

/** Maps a PAPI employee response to the ProfileInfo shape used by the profile UI. */
export function mapEmployeeToProfileInfo(employee: FintechPapiEmployee): ProfileInfo {
  return {
    jobTitle: (employee.job as FintechPapiJob)?.businessTitle || employee.basicInfo?.businessTitle,
    jobLevel: employee.job?.jobLevel,
    city: employee.workLocation?.city,
    buildingCode: employee.workLocation?.buildingCode,
    badgeColor: employee.basicInfo?.badgeColor
  };
}
